import type { QueryFunctionContext } from '@tanstack/react-query';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { asrProxyKeys } from 'app/queries/asrProxy/asrProxyKeys';
import type { TCall } from 'app/queries/types/TCall';
import { AsrProxyService } from './AsrProxyService';

type TParams = QueryFunctionContext<ReturnType<typeof asrProxyKeys.settings>>;

export const createFetchAsrSettingsQueryFn =
  (call: TCall) =>
  ({ signal }: TParams) =>
    call(() => cancelOnSignal(AsrProxyService.settings(), signal), { dontRedirectOnError: true });
